
import {
  TICKET_GET_TICKET,
  TICKET_TOGGLE_LOADING,
  TICKET_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  TICKET_TOGGLE_ACTIVITY_IS_OPEN,
  TICKET_SET_SHOW_COMMENT_FORM,
  TICKET_SET_COMMENT_VALUE,
  ISetTicketCommentValue,
  ISetTicketShowCommentForm,
  IAssignActivityIsOpenFields,
  ISetTicketAction,
  IToggleTicketLoadingAction,
  IToggleActivity,
  ISetTicketCommentProcessing,
  ISetTicketDescError,
  TICKET_SET_COMMENT_PROCESSING,
  TICKET_SET_DESC_ERROR,
  TICKET_UPDATE_ESCALATION_NOTE,
  IUpdateEscalationNote,
  TICKET_TOGGLE_MODAL,
  TICKET_ESCALATION_TOGGLE_MODAL,
  TICKET_SET_ESCALATION_MODAL_ERROR_TEXT,
  TOGGLE_TICKET_REASON_DROPDOWN,
  ITogglTicketReasonDropdownAction,
  IToggleTicketModalLoadingAction,
  TICKET_TOGGLE_MODAL_LOADING,
  TICKET_TOGGLE_ESCALATION_MODAL_LOADING,
  TICKET_ESCALATE_TICKET,
  IToggleTicketEscalationModalLoadingAction,
  TICKET_SET_ACTIVITY,
  TICKET_TOGGLE_ACTIVITY_CONTENT_LOADING,
  IToggleTicketActivityContentLoading, TICKET_SET_ACTIVITY_ERROR, IAddTicketActivityError,
} from './types';

import { defaultErrorFeedback, errorFeedback } from '../../actions/feedback';
import { setSystemError } from '../system/actions';
import { api_getTicketActivity, createTicket } from '../../utils/Tickets/Tickets';
import {api_deletePortalUserComment} from "../../utils/PortalUserComment/PortalUserCommentService";
import { addTicketToTickets } from 'store/tickets/actions';
import { api_escalateTicket, api_getTicket } from 'utils/Ticket/ticket';

export const setTicketCommentValue = (value): ISetTicketCommentValue => ({ type: TICKET_SET_COMMENT_VALUE, value });
export const setTicketCommentFormOpen = (): ISetTicketShowCommentForm => ({ type: TICKET_SET_SHOW_COMMENT_FORM });
export const setCommentProcessing = (payload): ISetTicketCommentProcessing => ({ type: TICKET_SET_COMMENT_PROCESSING, payload });
export const setDescError = (payload): ISetTicketDescError => ({ type: TICKET_SET_DESC_ERROR, payload });
export const ticketUpdateEscalationNote = (payload): IUpdateEscalationNote => ({ type: TICKET_UPDATE_ESCALATION_NOTE, payload });
export const ticketToggleModal = () => ({ type: TICKET_TOGGLE_MODAL });
export const ticketEscalationToggleModal = () => ({ type: TICKET_ESCALATION_TOGGLE_MODAL });
export const ticketEscalate = () => ({ type: TICKET_ESCALATE_TICKET });
export const ticketEscalationSetErrorText = (payload) => ({ type: TICKET_SET_ESCALATION_MODAL_ERROR_TEXT, payload });
export const toggleTicketReasonDropdownOpen = (): ITogglTicketReasonDropdownAction => ({ type: TOGGLE_TICKET_REASON_DROPDOWN });

export function updateTicketEscalated(ticketId, escalationNote) {

  return (dispatch) => api_escalateTicket(ticketId, escalationNote).then((result) => {

    if (result.status === 200) {

      return true;

    }
    dispatch(errorFeedback('Could not Escalate ticket'));
    return false;

  });

}
export function deletePortalUserComment(commentId) {
  return (dispatch) => api_deletePortalUserComment(commentId)
    .then((result) => {
      if (result.status >= 200 && result.status < 300) {
        return true;
      }
      dispatch(errorFeedback('Could not delete comment'));
      return false;
    });
}

function setTicket(data): ISetTicketAction {

  return {
    type: TICKET_GET_TICKET,
    data,
  };

}
export function toggleTicketLoading(): IToggleTicketLoadingAction {

  return {
    type: TICKET_TOGGLE_LOADING,
  };

}

export const toggleTicketModalLoading = (): IToggleTicketModalLoadingAction => ({ type: TICKET_TOGGLE_MODAL_LOADING });
export const toggleTicketEscalationModalLoading = (): IToggleTicketEscalationModalLoadingAction => ({ type: TICKET_TOGGLE_ESCALATION_MODAL_LOADING });

export function getTicket(ticketId, query: { include: string }) {

  return (dispatch) => api_getTicket(ticketId, query).then((result) => {

    if (result.status === 200) {

      dispatch(setTicket(result.data));

    } else if (result.data.error && result.data.error.id) {

      dispatch(errorFeedback(`Could not get ticket for id ${result.data.error.id}`));

    } else {

      dispatch(defaultErrorFeedback());

    }

  });

}
export function assignActivityIsOpenFields(): IAssignActivityIsOpenFields {

  return {
    type: TICKET_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  };

}
export function toggleActivity(id): IToggleActivity {

  return {
    type: TICKET_TOGGLE_ACTIVITY_IS_OPEN,
    id,
  };

}

export function toggleActivityContentLoading(id): IToggleTicketActivityContentLoading {

  return {
    type: TICKET_TOGGLE_ACTIVITY_CONTENT_LOADING,
    id,
  };

}

const setTicketActivity = (data) => ({
  type: TICKET_SET_ACTIVITY,
  data,
});
export const createNewTicket = (object) => (dispatch) => createTicket(object).then((result) => {

  if (result.status === 200) {

    dispatch(addTicketToTickets({ ...result.data, ticketNumber: result.data.ticketNumber }));
    return result.data;

  }

  return false;

});

export const getTicketActivity = (ticketId, activityId) => (dispatch) => api_getTicketActivity(ticketId, activityId).then((result) => {

  if (result.status === 200) {

    dispatch(setTicketActivity(result.data));
    return true;

  }

  return false;

});

export function setActivityError(id, error): IAddTicketActivityError {

  return {
    type: TICKET_SET_ACTIVITY_ERROR,
    id,
    error
  };

}
